"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var loadMessages_1 = require("./loadMessages");
exports.loadMessages = loadMessages_1.loadMessages;
var LocalizationProvider_1 = require("./LocalizationProvider");
exports.LocalizationProvider = LocalizationProvider_1.LocalizationProvider;
var LocalizationService_1 = require("./LocalizationService");
exports.LocalizationService = LocalizationService_1.LocalizationService;
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/Localization/main.js
// module id = 6608
// module chunks = 0